"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTextArea = exports.StyledLabel = exports.Container = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = require("../style/colors");
var _fonts = require("../style/fonts");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Container = exports.Container = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "style__Container",
  componentId: "bufferapp-ui__sc-1ozxwab-0"
})(["display:flex;flex-direction:column;height:100%;"]);
const backgroundCss = _ref => {
  let {
    disabled,
    hasError
  } = _ref;
  if (disabled) {
    return _colors.grayLight;
  }
  if (hasError) {
    return _colors.redLightest;
  }
  return _colors.white;
};
const borderCss = _ref2 => {
  let {
    disabled,
    hasError
  } = _ref2;
  if (disabled) {
    return 'none';
  }
  if (hasError) {
    return `1px solid ${_colors.redDark}`;
  }
  return `1px solid ${_colors.gray}`;
};
const StyledTextArea = exports.StyledTextArea = /*#__PURE__*/_styledComponents.default.textarea.withConfig({
  displayName: "style__StyledTextArea",
  componentId: "bufferapp-ui__sc-1ozxwab-1"
})(["border-radius:4px;box-shadow:2px 2px 0 2px transparent;transition-property:border-width,border-color,box-shadow;transition-duration:0.1s;transition-timing-function:ease-in;background-color:", ";border:", ";box-sizing:border-box;margin-top:8px;margin-bottom:8px;resize:none;cursor:", ";padding:8px;color:", ";font-family:", ";font-size:", ";font-weight:", ";line-height:", ";height:", ";:focus{border:1px solid ", ";box-shadow:0px 0px 0px 3px ", ";outline:none;transition-property:border-width,border-color,box-shadow;transition-duration:0.1s;transition-timing-function:ease-in;}&::placeholder{color:", ";}"], props => backgroundCss({
  disabled: props.disabled,
  hasError: props.hasError
}), props => borderCss({
  disabled: props.disabled,
  hasError: props.hasError
}), props => props.disabled ? 'not-allowed' : '', _ref3 => {
  let {
    hasError
  } = _ref3;
  return hasError ? _colors.redDark : _colors.grayDarker;
}, _fonts.fontFamily, _fonts.fontSize, _fonts.fontWeight, _fonts.lineHeight, _ref4 => {
  let {
    fullHeight
  } = _ref4;
  return fullHeight ? '100%' : 'auto';
}, _ref5 => {
  let {
    hasError
  } = _ref5;
  return hasError ? _colors.redDark : _colors.blue;
}, _ref6 => {
  let {
    hasError
  } = _ref6;
  return hasError ? _colors.redLighter : _colors.boxShadow;
}, _colors.grayDark);
const StyledLabel = exports.StyledLabel = /*#__PURE__*/_styledComponents.default.label.withConfig({
  displayName: "style__StyledLabel",
  componentId: "bufferapp-ui__sc-1ozxwab-2"
})(["display:flex;flex-direction:column;"]);